import React, { InputHTMLAttributes, TextareaHTMLAttributes } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

const Input = styled.textarea`
  min-height: 42px;
  border: 1px solid #c9c9c9;
  width: 100%;
  font-size: 14px;
  color: #080808;
  opacity: 0.8;
  border-radius: 0px;
  padding: 0px 5px;

  &::placeholder {
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    /* identical to box height, or 171% */

    letter-spacing: -0.01em;

    color: #bebfc6;
  }
`;

const Label = styled.label`
  display: flex;
  margin-bottom: 5px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 22px;
  /* identical to box height, or 183% */

  letter-spacing: -0.01em;

  color: #1e2029;

  /* Inside Auto Layout */
`;

function TextArea({ inputLabel, ...rest }: ITextArea) {
    return (
        <Wrapper>
            {inputLabel && <Label htmlFor={"input-" + rest.name}>{inputLabel}</Label>}
            <Input id={"input-" + rest.name} {...rest} />
        </Wrapper>
    );
}

export interface ITextArea extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    inputLabel?: string;
}

export default TextArea;
